import { Text, chakra, Box, Grid } from "@chakra-ui/react";
import { Fragment } from "react";

const SimpleTable = ({ data, children, ...rest }) => (
  <Grid bg="whiteAlpha.700" p={4} columnGap={8} gridTemplateColumns="1fr 1fr" {...rest}>
    {children}
    {Object.entries(data).map(([key, value]) => {
      let valueAsString = value;
      if (Array.isArray(value)) {
        valueAsString = value.join(", ");
      } else if (value === true || value === false) {
        valueAsString = value ? "Yes" : "No";
      } else if (value === null || value === undefined) {
        return;
      }
      return (
        <Fragment key={key}>
          <Text key={key} fontSize="2xl" lineHeight="1.25em">
            {key}
          </Text>
          <Text textAlign="right" fontWeight="bold" fontSize="2xl" lineHeight="1.25em">
            {valueAsString}
          </Text>
        </Fragment>
      );
    })}
  </Grid>
);

export default SimpleTable;
